import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import usePrevious from '@ifit/hooks/usePrevious';
import debounce from 'lodash.debounce';
import { useCurrentSoftwareNumber } from '../../store/software-number';

export const RestoreScroll: React.FC = ({ children }) => {
  const { pathname } = useLocation();
  const { action } = useHistory();
  const restoreRef = useRef();

  const [scrollPositions, setScrollPositions] = useState({});
  const [targetDocHeights, setTargetDocHeights] = useState({});
  const [docHeight, setDocHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [scrollPending, setScrollPending] = useState(false);
  const [currentPath, setCurrentPath] = useState(pathname);
  const currentSoftwareNumber = useCurrentSoftwareNumber();
  const previousSoftwareNumber = usePrevious(currentSoftwareNumber);

  useEffect(() => {
    const handleScroll = debounce(() => {
      setScrollY(window.pageYOffset);
    }, 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (currentSoftwareNumber !== previousSoftwareNumber) {
      setScrollPositions({ [currentPath]: 0 });
      setTargetDocHeights({ [currentPath]: docHeight });
      setScrollPending(true);
    }
  }, [currentSoftwareNumber, previousSoftwareNumber, currentPath, docHeight]);

  useEffect(() => {
    setScrollPending(true);
    setCurrentPath(pathname);
  }, [pathname]);
  useLayoutEffect(() => {
    new MutationObserver(() => {
      setDocHeight(window.document.documentElement.offsetHeight);
    }).observe(restoreRef.current, {
      childList: true,
      subtree: true,
    });
  }, [restoreRef]);
  useEffect(() => {
    if (!scrollPending) {
      setScrollPositions(prevState => ({
        ...prevState,
        [currentPath]: scrollY,
      }));
      setTargetDocHeights(prevState => ({
        ...prevState,
        [currentPath]: docHeight,
      }));
    }
  }, [currentPath, scrollY, docHeight, scrollPending]);
  useEffect(() => {
    if (scrollPending) {
      if (action === 'POP' && docHeight >= targetDocHeights[currentPath]) {
        window.scrollTo(0, scrollPositions[currentPath] || 0);
        setScrollPending(false);
      } else if (action !== 'POP') {
        window.scrollTo(0, 0);
        setScrollPending(false);
      }
    }
  }, [
    docHeight,
    targetDocHeights,
    scrollPending,
    currentPath,
    scrollPositions,
    action,
  ]);

  return <div ref={restoreRef}>{children}</div>;
};

export default withRouter(RestoreScroll);
